<template>
  <div>
    <Modal v-model="editModal" title="修改员工" :mask-closable="false">
      <Form
        ref="updateModelFrom"
        :model="modelData"
        :rules="ruleDate"
        :label-width="87"
      >
        <FormItem label="姓名：" prop="staffName">
          <Input v-model="modelData.staffName"></Input>
        </FormItem>
        <FormItem label="手机号：" prop="mobile">
          <Input v-model="modelData.mobile" disabled ></Input>
        </FormItem>
        <FormItem label="性别：" prop="gender">
          <Select v-model="modelData.gender">
            <Option value="1">男</Option>
            <Option value="2">女</Option>
          </Select>
        </FormItem>
        <FormItem label="角色：" prop="roleId">
          <Select v-model="modelData.roleId">
            <Option
              v-for="item in roleList"
              :value="item.id"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="提交订单：">
          <Select v-model="modelData.isCommit">
            <Option value="0">可提交订单</Option>
            <Option value="1">不可提交订单</Option>
          </Select>
        </FormItem>
        <FormItem label="入职时间：">
          <DatePicker
            format="yyyy-MM-dd"
            style="width: 100%"
            type="date"
            placeholder="请选择入职时间"
            v-model="modelData.entryTime"
          ></DatePicker>
        </FormItem>
      </Form>
      <div slot="footer" class="footer">
        <Button type="error" :loading="editLoading" @click="editSave()"
          >确定</Button
        >
        <Button type="default" @click="cancel()" style="background: #fff;color:#377CF1;margin-right: 120px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { editStaff } from '@/api/myweb/organization/staffManagement'
import { dataMixin } from './datamixin.js'
export default {
  mixins: [dataMixin],

  computed: {},
  created() {},
  data() {
    return {
      modelData: {
        mobile: '',
        staffName: '',
        gender: '',
        entryTime: '',
        roleId: ''
      },
      editModal: false,
      editLoading: false,
      defaultRoleId: '', // 所属角色
      roleList: [],
      ruleDate: {
        staffName: [
          {
            required: true,
            message: '员工姓名不能为空',
            trigger: 'blur'
          },
          {
            type: 'string',
            max: 20,
            message: '最多输入20个字',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        roleId: [
          {
            required: true,
            message: '角色不能为空',
            trigger: 'blur'
          }
        ],
        gender: [
          {
            required: true,
            message: '性别不能为空',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    getData(data) {
      const obj = JSON.parse(JSON.stringify(data))
      this.$refs.updateModelFrom.resetFields()
      this.getRoleList()
      obj.gender = String(obj.gender)
      obj.isCommit = String(obj.isCommit)
      this.modelData = obj
      this.editModal = true
    },
    // 保存
    editSave() {
      this.$refs.updateModelFrom.validate(async (valid) => {
        if (valid) {
          this.editLoading = true
          let data = JSON.parse(JSON.stringify(this.modelData))
          data.entryTime = data.entryTime ? data.entryTime.substr(0, 10) : ''
          let res = await editStaff(data)
          console.log(res)
          if (res.status) {
            this.$Message.success('保存成功!')
            this.editModal = false
            this.$parent.getStaffList()
          } else {
            // this.$Message.error(res.message)
          }
          this.editLoading = false
        } else {
          this.$Message.error('您有必填信息还未填写!')
        }
      })
    },
    cancel() {
      this.editModal = false
    }
  }
}
</script>

<style lang="less" scoped>
// /deep/.ivu-form-item-error-tip {
//   top: 20%;
//   left: 100px;
// }
.ivu-form-item-content {
  position: relative;
}
.eyeIcon {
  position: absolute;
  right: 20px;
  top: 10px;
  cursor: pointer;
}
//修改弹窗按钮
.footer{
  Button{
    width: 80px;
    height: 30px;
    background: #377CF1;
    opacity: 1;
    border-radius: 2px;
    border:1px solid #377CF1;
    text-align: center;
  }
}
//修改弹框
 /deep/ .ivu-modal-content {
 padding-bottom: 10px;
  width: 450px;
  height: 430px;
  position: relative;
  background-color: #fff;
  border: 0;
  border-radius: 0px !important;
  background-clip: padding-box;
  box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
}
//修改弹框X
/deep/ .ivu-modal-close {
    z-index: 1;
    font-size: 10px;
    position: absolute;
    right: 8px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    top: 10px;
    background-color: #BBBBBB;
    overflow: hidden;
    cursor: pointer;
}
/deep/ .ivu-modal-close .ivu-icon-ios-close {
    font-size: 30px;
    color: #fbfbfb;
    top: -4px;
    left: -4.5px;
}
//修改弹窗头部
/deep/ .ivu-modal-header {
    border-bottom: 1px solid #e8eaec;
    padding: 10px 16px !important;
    line-height: 1;
    background: #F0F0F0;
}
/deep/ .ivu-modal-header-inner {
    display: inline-block;
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #555555;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    opacity: 1;
}
//修改弹窗文本框宽度修改
/deep/ .ivu-input-wrapper {
    width: 323px;
    height: 30px !important;
}
//修改弹窗文本间距修改
/deep/ .ivu-form-item {
    margin-bottom: 18px !important;
    padding-left: 10px;
}
//修改弹窗下拉框宽度修改
/deep/ .ivu-select {
    width: 323px !important;
}
/deep/ .ivu-modal-body {
  margin-top:10px;
  padding: 0px !important;
}
/deep/.ivu-input {
    height: 30px !important;
}
//修改弹窗按钮边距
/deep/ .ivu-modal-footer {
    padding: 10px 18px 12px 18px !important;
}
</style>
